import * as React from 'react';

interface IProps {
  onClickOutside: (e: TouchEvent | MouseEvent | FocusEvent) => void;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

/**
 * @description componenent that registers clicks outside,
 * 	ported from https://github.com/tj/react-click-outside
 */
const ClickOutside = (props: IProps): React.ReactElement => {
  const ref = React.useRef(null);
  const isTouch = React.useRef(false);

  const handle = (e: TouchEvent | MouseEvent | FocusEvent): void => {
    if (e.type === 'touchend') isTouch.current = true;
    if (e.type === 'click' && isTouch.current) return;
    const { onClickOutside } = props;
    const el = ref.current;
    if (el && !el.contains(e.target)) {
      onClickOutside(e);
    }
  };

  React.useEffect((): (() => void) => {
    document.addEventListener('touchend', handle, true);
    document.addEventListener('click', handle, true);
    document.addEventListener('focus', handle, true);
    return (): void => {
      document.removeEventListener('touchend', handle, true);
      document.removeEventListener('click', handle, true);
      document.removeEventListener('focus', handle, true);
    };
  }, []);
  return (
    <div
      ref={ref}
      style={{ position: 'relative', width: 'min-content', ...props.style }}
    >
      {props.children}
    </div>
  );
};

export default ClickOutside;
